import { Box, Grid, Typography, Button } from "@mui/material";
import React from "react";
import "./Competitions.css";
import { Images } from "../../../../helpers/Images";
import { useNavigate } from "react-router-dom";

const CompetitionsSection = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        width: "100%",
        padding: {
          xs: "50px 20px 20px 20px",
          sm: "50px 60px",
          lg: "70px 120px",
        },
        backgroundColor: "secondary.main",
        maxWidth: "1500px",
        margin: "auto",
      }}
    >
      <Typography
        variant={"h2"}
        sx={{
          textAlign: "center",
          fontSize: "35px",
          fontWeight: "500",
          color: "primary.darker",
          marginBottom: "5px",
        }}
      >
        New Categories
      </Typography>
      <Box
        sx={{
          height: "3px",
          width: "250px",
          backgroundColor: "primary.main",
          margin: "auto",
        }}
      />
      <Box
        sx={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "space-around",
          flexDirection: { xs: "column", md: "row" },
          marginTop: "40px",
          gap: "20px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: { xs: "100%", md: "50%" },
          }}
        >
          <img
            src={Images.roboBoom}
            style={{
              maxHeight: "300px",
              width: "fit-content",
              margin: "auto",
              maxWidth: "500px",
              width: "100%",
              borderRadius: "10px",
            }}
          />
          <Typography
            variant={"p"}
            sx={{
              textAlign: "center",
              fontSize: "17px",
              fontWeight: "500",
              color: "black",
              maxWidth: { xs: "100%", md: "80%" },
              margin: "auto",
              marginTop: "20px",
            }}
          >
            RoboBoom is an exciting robotics competition where participants aged
            6-10 years old design and build robots to compete in dynamic
            challenges, showcasing their engineering and programming skills.
          </Typography>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              margin: "auto",
            }}
          >
            <Button
              sx={{
                fontSize: "15px",
                margin: "10px 0 40px 0",
                fontWeight: "600",
                color: "secondary.main",
                backgroundColor: "primary.main",
              }}
              variant="contained"
              color="secondary"
              onClick={() => navigate("/competition/robo-boom")}
            >
              Learn More About RoboBoom
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: { xs: "100%", md: "50%" },
          }}
        >
          <img
            src={Images.roboGolf}
            style={{
              maxHeight: "300px",
              width: "fit-content",
              margin: "auto",
              maxWidth: "500px",
              width: "100%",
              borderRadius: "10px",
            }}
          />
          <Typography
            variant={"p"}
            sx={{
              textAlign: "center",
              fontSize: "17px",
              fontWeight: "500",
              color: "black",
              maxWidth: { xs: "100%", md: "80%" },
              margin: "auto",
              marginTop: "20px",
            }}
          >
            RoboGolf combines the precision of golf with robotics innovation,
            challenging participants aged 6-10 years old to create robots that
            can navigate and play golf in an automated environment.
          </Typography>
          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Button
              variant="contained"
              color="secondary"
              sx={{
                fontSize: "15px",
                margin: "10px 0 40px 0",
                fontWeight: "600",
                color: "secondary.main",
                backgroundColor: "primary.main",
              }}
              onClick={() => navigate("/competition/robo-golf")}
            >
              Learn More About RoboGolf
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CompetitionsSection;
